export const bounce = `
	0%, 100% {
		animationTimingFunction: cubic-bezier(0.8, 0, 1, 1);
		transform: translateY(-25%);
	}
	50% {
		animationTimingFunction: cubic-bezier(0, 0, 0.2, 1);
		transform: translateY(0);
	}
`

export const fadeDown = (distance: number) => `
	from {
		opacity: 0;
		transform: translateY(-${distance}px)
	}
	to {
		opacity: 1;
		transform: translateY(0)
	}
`

export const fadeIn = `
	from {
		opacity: 0;
	}
	to {
		opacity: 1;
	}
`

export const fadeLeft = (distance: number) => `
	from {
		opacity: 0;
		transform: translateX(${distance}px)
	}
	to {
		opacity: 1;
		transform: translateX(0)
	}
`

export const fadeOut = `
	from {
		opacity: 1;
	}
	to {
		opacity: 0;
	}
`

export const fadeRight = (distance: number) => `
	from {
		opacity: 0;
		transform: translateX(-${distance}px)
	}
	to {
		opacity: 1;
		transform: translateX(0)
	}
`

export const fadeUp = (distance: number) => `
	from {
		opacity: 0;
		transform: translateY(${distance}px)
	}
	to {
		opacity: 1;
		transform: translateY(0)
	}
`

export const pulse = `
	0%, 100% {
		opacity: 1;
	}
	50% {
		opacity: .5;
	}
`

export const spin = `
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(360deg);
	}
`
